import EditIcon from '@mui/icons-material/Edit';
import { Button, Tooltip } from '@mui/material';
import React from 'react';

/**
 * This function represents an edit button.
 * @returns React.Component
 */
export default function EditButton({ disabled, title, onChange, onClick }) {
  return (
    <Tooltip title={title ? title : 'Bewerken'}>
      <span>
        <Button
          disabled={disabled}
          onChange={onChange}
          onClick={onClick}
          style={{
            maxWidth: '35px',
            minWidth: '35px',
            maxHeight: '35px',
            minHeight: '35px',
            color: disabled ? 'gray' : 'black',
            borderRadius: '5px',
            marginRight: '10px',
            cursor: disabled ? 'default' : 'pointer',
            border: '1px solid',
          }}
        >
          <EditIcon />
        </Button>
      </span>
    </Tooltip>
  );
}
